import React, { useState, useEffect } from 'react';
import { Card, Table, Input } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from '../util/axiosConfig'
import '../styles/userlist.css'
import { usePagination } from '../context/PaginationProvider';

const { Search } = Input;

const ToleranceList: React.FC = () => {
    const { pagination, setTotal, setPage, setPageSize } = usePagination();
    const { page, pageSize, sort_by, sort_order } = pagination;
    const [toleranceList, setToleranceList] = useState<any>([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [searchKey, setSearchKey] = useState('');
    const [paginationConfig, setPaginationConfig] = useState({
        current: page,
        pageSize: pageSize,
        total: 0,
        showTotal: (total: number, range: [number, number]) => `Showing ${range[0]}-${range[1]} of ${total} entries`,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50"],
        locale: { items_per_page: "" },
        onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: page,
                pageSize: pageSize,
            }));
        },
        onShowSizeChange: (current: number, size: number) => {
            setPage(current);
            setPageSize(size);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: current,
                pageSize: size,
            }));
        },
    });

    const fetchToleranceList = async () => {
        setLoading(true);
        try {
            const response = await axios.post('/po-document-type/pageable-document-type', {}, {
                params: {
                    pageSize: pageSize,
                    pageNo: page - 1,
                    sortByField: sort_by,
                    sortDirection: 'desc',
                    search: searchKey
                },
            });
            const content = response?.data?.data?.content || [];
            if (Array.isArray(content)) {
                setToleranceList(content);
                setTotal(response.data?.data?.totalElements || 0);
                setPaginationConfig((prev) => ({
                    ...prev,
                    total: response.data?.data?.totalElements || 0,
                }));
            } else {
                console.error('Unexpected response format:', response.data);
            }
        } catch (error) {
            console.error('Failed to fetch panel data', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchToleranceList();
        // eslint-disable-next-line
    }, [searchKey, page, pageSize, sort_by, sort_order]);

    const handleEdit = (id: any, record: any) => {
        navigate(`/toleranceUpdate/${id}`);
    };

    const handleSearch = (value: string) => {
        setSearchKey(value);
    };

    const columns: any = [
        {
            title: 'Document Type',
            dataIndex: 'docType',
            key: 'docType'
        },
        {
            title: 'Value Type',
            dataIndex: 'valueTypeString',
            key: 'valueTypeString',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Percentage',
            dataIndex: 'percentageTolerance',
            key: 'percentageTolerance'
        },
        {
            title: 'Value',
            dataIndex: 'valueTolerance',
            key: 'valueTolerance'
        },
        {
            title: 'Action',
            key: 'action',
            width: '20%',
            render: (text: any, record: any) => (
                <>
                    <EditOutlined style={{ cursor: 'pointer' }} onClick={() => handleEdit(record?.id, record)} />
                </>
            ),
        },
    ];

    return (
        <>
            <Card
                title="Tolerance List"
                bordered={false}
                extra={
                    <Search
                        placeholder="Search..."
                        className="mt-2"
                        allowClear
                        onSearch={handleSearch}
                        style={{
                            width: 250,

                        }}
                    />
                }
            >
                <Table
                    loading={loading}
                    className='roleTable'
                    dataSource={toleranceList}
                    columns={columns}
                    bordered={false}
                    pagination={paginationConfig}
                    size='small'
                />
            </Card>
        </>
    );
};

export default ToleranceList;
